import React from 'react';
import AUTORECHARGE_LOCALE from '../../../assets/locale/autorecharge-locale';
import { Picto, RecurringPayment56, TextStyle } from '@able/react';
import { getExpiry } from '../../../adapters/utils';
import { addDataLayerEventInfo } from '../../../adapters/analytics-utils';

const AutoRechargeEnabledCard = (props) => {
    const { loggedIn = false, hasTdiLogin = false, newOfferSelected: { usageQuota = '', autoRechargeBonusData = '', autoRechargePercentage = '', autoRechargePrice = '', num } = {}, actualAmount = 0, starterCredit = 0, priceBeforeDiscount = 0 } = props;
    const {
        AutoRechargeEnabledCard: { autoRechargeContent = '', authPara1 = '', unauthpara1 = '', title = '' }
    } = AUTORECHARGE_LOCALE;
    const price = priceBeforeDiscount  || actualAmount || starterCredit;
    const expiry = getExpiry(usageQuota);
    if (!hasTdiLogin) {
        addDataLayerEventInfo('impression', 'auto recharge module', 'success', 'Auto recharge enabled - New TDI');
    } else {
        addDataLayerEventInfo('impression', 'auto recharge module', 'success', 'Auto recharge enabled - Existing TDI');
    }
    return (
        <div className="ag-arenabled-card">
            <Picto className="able-boost-picto">
                <RecurringPayment56 />
            </Picto>
            <TextStyle element={'h3'} alias="HeadingC">
                {title}
            </TextStyle>
            <div className="ag-arenabled-card--features">
                <TextStyle alias="Base">
                    {autoRechargeContent}${price} every {expiry}.
                </TextStyle>
                <TextStyle>
                    {autoRechargeBonusData ?
                        `You'll receive ${autoRechargeBonusData} bonus data on your next ${num} recharges as part of your auto recharge special offer.` :
                        autoRechargePrice ?
                            `You'll receive ${autoRechargePrice} off your next ${num} recharges.` : autoRechargePercentage ?
                                `You'll receive ${autoRechargePercentage} off your next ${num} recharges.` :
                                null}
                </TextStyle>
                <TextStyle alias="Base">
                    {loggedIn || hasTdiLogin ? authPara1 : unauthpara1}
                </TextStyle>
            </div>
        </div>
    );
};

export default AutoRechargeEnabledCard;
